export {
  formatBytes,
  formatDateTime as formatRunDate,
} from "shared-core/utils/format";
import { formatDuration as sharedFormatDuration } from "shared-core/utils/format.ts";

type DurationTranslator = (key: string, params: { count: number }) => string;

export async function formatDuration(
  duration: number,
  translator: DurationTranslator,
  shortFormat: boolean = false,
): Promise<string> {
  return await sharedFormatDuration(
    duration,
    (key, params) =>
      Promise.resolve(translator(key, params as { count: number })),
    shortFormat,
  );
}
